import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MediaRealmApiService {
  constructor(private http: HttpClient) {}

  readonly mediaRealmUrl: string = 'topology/mediaRealm';

  public getMediaRealm(): Observable<any> {
    return this.http.get(this.mediaRealmUrl);
  }
}
